export const BASE = {
  '--app-primary-color': 'hsl(215, 22%, 53%)',
  '--app-secondary-color': 'hsl(205, 100%, 15%)',
  '--app-tertiary-color': 'hsl(205, 50%, 90%)',
  '--app-disabled-color': 'hsl(220, 12%, 95%)',
  '--sidebar-bg-color': 'hsl(211, 22%, 53%)',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': 'hsl(49, 100%, 50%)',
  '--sidebar-active-text-color': 'hsl(0, 0%, 0%)'
};

export const ADULTS = {
  '--app-primary-color': 'hsl(215, 22%, 53%)',
  '--app-secondary-color': 'hsl(205, 100%, 15%)',
  '--app-tertiary-color': 'hsl(205, 50%, 90%)',
  '--app-disabled-color': 'hsl(220, 12%, 95%)',
  '--sidebar-bg-color': 'hsl(211, 22%, 53%)',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': 'hsl(49, 100%, 50%)',
  '--sidebar-active-text-color': 'hsl(0, 0%, 0%)'
};

export const INFANTS = {
  '--app-primary-color': 'hsl(215, 22%, 53%)',
  '--app-secondary-color': 'hsl(205, 100%, 15%)',
  '--app-tertiary-color': 'hsl(205, 50%, 90%)',
  '--app-disabled-color': 'hsl(220, 12%, 95%)',
  '--sidebar-bg-color': 'hsl(211, 22%, 53%)',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': 'hsl(49, 100%, 50%)',
  '--sidebar-active-text-color': 'hsl(0, 0%, 0%)'
};

export const GESTANTS = {
  '--app-primary-color': 'hsl(215, 22%, 53%)',
  '--app-secondary-color': 'hsl(205, 100%, 15%)',
  '--app-tertiary-color': 'hsl(205, 50%, 90%)',
  '--app-disabled-color': 'hsl(220, 12%, 95%)',
  '--sidebar-bg-color': 'hsl(211, 22%, 53%)',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': 'hsl(49, 100%, 50%)',
  '--sidebar-active-text-color': 'hsl(0, 0%, 0%)'
};
